"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var submit_button_1 = __importDefault(require("@hikakaku/shared/components/estimate_form/common/submit_page_footer/submit_button"));
var annotation_1 = __importDefault(require("@hikakaku/shared/components/estimate_form/common/submit_page_footer/annotation"));
var SubmitPageFooter = (0, mobx_react_1.observer)(function (_a) {
    var store = _a.store;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(submit_button_1.default, { onClick: store.handleClickSubmitButton, disabled: !store.isSubmitButtonEnabled, text: store.submitButtonText, className: store.submitButtonClassNames }),
        react_1.default.createElement(annotation_1.default, null),
        react_1.default.createElement("button", { onClick: store.handleClickPrevButton, className: "estimateForm-SubmitPageFooter_PrevButton" }, "\u623B\u308B")));
});
exports.default = SubmitPageFooter;
